import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const HeartFilled = createIcon({
  displayName: "HeartFilled",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Heart Filled icon </title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.89999C12 6.89999 10.27 4.73999 8.05 4.73999C7.24591 4.75592 6.4625 4.99756 5.78914 5.43733C5.11578 5.8771 4.5796 6.4973 4.24178 7.22716C3.90396 7.95701 3.77811 8.76713 3.87858 9.56508C3.97905 10.363 4.3018 11.1167 4.81 11.74C5.35 12.44 11.29 18.41 11.29 18.41C11.3826 18.5045 11.4931 18.5796 11.6149 18.6311C11.7368 18.6826 11.8677 18.7094 12 18.71C12.2638 18.7062 12.5154 18.5984 12.7 18.41C12.7 18.41 18.65 12.41 19.19 11.74C19.6982 11.1167 20.021 10.363 20.1214 9.56508C20.2219 8.76713 20.096 7.95701 19.7582 7.22716C19.4204 6.4973 18.8842 5.8771 18.2109 5.43733C17.5375 4.99756 16.7541 4.75592 15.95 4.73999C13.73 4.73999 12 6.89999 12 6.89999Z"
      />
    </>
  )
});
